import { RainfallTable } from '../components/RainfallTable';
import { Section } from '../components/Section';
import { stationsPerCity } from '../constants/stations';
import styles from '../styles/estacoes.module.css';

function getCityName(title: string) {
  return title
    .replace('Estações localizadas em ', '')
    .replace('/RS', '')
    .trim();
}


export default function Estacoes() {
  const stationGroups = stationsPerCity.filter(
    (city) => !city.title.toLowerCase().includes('mapa'),
  );
  const mapGroup = stationsPerCity.find((city) =>
    city.title.toLowerCase().includes('mapa'),
  );
  const mapStation = mapGroup?.stations[0];
  const stationCount = stationGroups.reduce(
    (total, city) => total + city.stations.length,
    0,
  );

  return (
    <Section className={styles.page}>
      <div className="col-12">
        <header className={styles.hero}>
          <div>
            <span className={styles.eyebrow}>Rede de monitoramento</span>
            <h1>Estações meteorológicas</h1>
            <p>
              Acompanhe as informações meteorológicas de Rolante, Riozinho e São Francisco de Paula disponibilizados pelos seguintes órgãos: CEMADEN (Centro Nacional de Monitoramento e Alertas de Desastres Naturais), Defesa Civil Estadual, Defesa Civil Municipal, INMET (Instituto Nacional de Meteorologia), GPDEN - UFRGS (Grupo de Pesquisas em Desastres Naturais da Universidade Federal do Rio Grande do Sul) e SIMAGRO (Sistema de Monitoramento e Alertas Agroclimáticos do Rio Grande do Sul).
            </p>
          </div>
          <div className={styles.heroStats} aria-label="Resumo das estações">
            <strong>{stationCount}</strong>
            <span>estações disponíveis</span>
          </div>
        </header>
      </div>

      <div className="col-12">
        <section className={styles.weatherPanel}>
          <div className={styles.sectionHeader}>
            <div>
              <span className={styles.eyebrow}>Tempo real</span>
              <h2>Informações meteorológicas</h2>
            </div>
          </div>
          <RainfallTable />
        </section>
      </div>

      <div className="col-12">
        <section className={styles.overview}>
          {mapStation && (
            <a
              href={mapStation.url}
              className={styles.mapFeature}
              target="_blank"
              rel="noreferrer"
            >
              <img src={mapStation.image[0]} alt="Mapa das estações" />
              <div>
                <span className={styles.eyebrow}>Mapa interativo</span>
                <h2>Localização das estações</h2>
                <p>{mapStation.title}</p>
                <span className={styles.inlineAction}>
                  Abrir mapa <i className="bi bi-arrow-up-right" aria-hidden />
                </span>
              </div>
            </a>
          )}

          <div className={styles.citySummary}>
            <div className={styles.sectionHeader}>
              <div>
                <span className={styles.eyebrow}>Municípios</span>
                <h2>Cobertura da rede</h2>
              </div>
            </div>

            {stationGroups.map((city) => (
              <a
                href={`#${getCityName(city.title)
                  .toLowerCase()
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .replace(/[^a-z0-9]+/g, '-')}`}
                className={styles.citySummaryItem}
                key={city.title}
              >
                <span>{getCityName(city.title)}</span>
                <strong>{city.stations.length}</strong>
              </a>
            ))}
          </div>
        </section>
      </div>

      {stationGroups.map((city) => {
        const cityName = getCityName(city.title);
        const cityId = cityName
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-');

        return (
          <section
            className={`col-12 ${styles.cityBlock}`}
            key={city.title}
            id={cityId}
          >
            <div className={styles.sectionHeader}>
              <div>
                <span className={styles.eyebrow}>Estações por município</span>
                <h2>{cityName}/RS</h2>
              </div>

            </div>

            <div className={styles.stationGrid}>
              {city.stations.map((station) => (
                <a
                  key={`${city.title}-${station.title}`}
                  href={station.url}
                  className={styles.stationCard}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={station.image[0]} alt={station.title} />
                  <div className={styles.stationCardBody}>
                    <div>
                      <h3>{station.title}</h3>

                    </div>
                  </div>
                </a>
              ))}
            </div>
          </section>
        );
      })}
    </Section>
  );
}
